export interface Entity {
  entityid?: string,
  email?: string,
  prefix?: string,
  firstname?: string,
  lastname?: string,
  scope?: string,
  phone?: string,
  lang?: string,

}

export interface EntityResponse {
  entityid?: BigInteger,
  entitytype?:string,
  aadhaarid?:string,
  prefix?: string,
  firstname?: string,
  lastname?: string,
  company?: string,
  phone?: string,
  email?: string,
  password?: string,
  lang?:string,
  entityvalidated?: string,
  id?: BigInteger,
  memberName?: string,
  validated?: boolean,
  scope?: string,
  id_token?: string
}